import { z } from "zod"

export const productsDetectMetadataInputSchema = z.object({
	products: z
		.array(
			z.object({
				productId: z.string().uuid(),
				name: z.string(),
				description: z.string().optional(),
			}),
		)
		.min(1),
})

export const productsDetectMetadataOutputSchema = z.object({
	success: z.boolean(),
})

export type ProductsDetectMetadataProgressPhase =
	| { kind: "analyzing"; count: number }
	| { kind: "detected"; count: number }
	| { kind: "fallback" }
	| { kind: "done" }

export type ProductsDetectMetadataInput = z.infer<
	typeof productsDetectMetadataInputSchema
>
export type ProductsDetectMetadataOutput = z.infer<
	typeof productsDetectMetadataOutputSchema
>
